<!--  -->
<template>
    <div class="container">
         <mapTop
        ref="mapAddress"
        
        v-show="false"
    />
        <div class="titleImg">
            <img :src="baseImgHost+tourInfo.img" alt="">
        </div>
        <!-- <div class="music">
            <div>
                <Audio
                ref="audio"
                :spointx="spointx"
                :spointy="spointy"
                :isEnglish="isEnglish"
                :audioInfo="tourInfo"
                @audioOpen='audioOpen'
                v-show="true"
                :className="'tourGLaudio'"
            />
            </div> 
        </div> -->
        <div class="tourMsg">
            <ul>
                <li>
                   
                    <p><svg t="1637313249094" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19574" width="24" height="24"><path d="M631.203181 417.860865a252.517801 252.517801 0 1 0 252.514807 252.514808 252.799251 252.799251 0 0 0-252.514807-252.514808z" fill="#FFE39C" p-id="19575"></path><path d="M510.865216 132.422363c-230.27724 0-417.612351 187.341099-417.612351 417.609356s187.335111 417.609357 417.612351 417.609357 417.609357-187.332117 417.609357-417.609357S741.133474 132.422363 510.865216 132.422363z m0 770.970198a353.360842 353.360842 0 1 1 353.360842-353.360842 353.759064 353.759064 0 0 1-353.360842 353.360842z" fill="#333333" p-id="19576"></path><path d="M619.94517 714.524444a35.878924 35.878924 0 0 1-25.546106-10.566362l-111.439345-111.439345a27.911485 27.911485 0 0 1-8.224935-19.866199v-183.10138a36.127439 36.127439 0 1 1 72.251883 0v164.795134l98.507602 98.507603a36.130433 36.130433 0 0 1-25.543111 61.679532z" fill="#333333" p-id="19577"></path></svg>
                       <span>
                            {{tourInfo.start_time}}-{{tourInfo.end_time}}
                       </span>
                    </p>
                 
                </li>
                <li>
                    <p>
                     <svg t="1637313183613" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19384" width="24" height="24"><path d="M627.355696 394.120234c-112.616047-31.193076-230.609591 37.073591-263.027275 152.177778a218.273684 218.273684 0 0 0 3.371415 128.88028l0.062877 0.218573a40.687532 40.687532 0 0 0 2.395322 7.212913l83.237427 220.168982a38.624561 38.624561 0 0 0 25.944327 23.896328 38.624561 38.624561 0 0 0 34.573474-7.138059l184.739181-146.021801a43.792468 43.792468 0 0 0 6.030223-5.224795l0.116772-0.10779a223.010433 223.010433 0 0 0 69.353543-108.364351c31.923649-115.247906-33.917754-234.436117-146.797286-265.698058z" fill="#FFE39C" p-id="19385"></path><path d="M527.710316 59.883041C326.769778 59.883041 162.573474 219.438409 161.684211 415.564351a346.399439 346.399439 0 0 0 64.754526 202.222035l0.203602 0.320374a66.601918 66.601918 0 0 0 7.284772 10.350784l239.020164 311.54152a67.464234 67.464234 0 0 0 53.960608 26.411416 67.494175 67.494175 0 0 0 53.969591-26.408422l239.11897-311.676257a71.197942 71.197942 0 0 0 7.590176-10.898713l0.143719-0.221568a353.959673 353.959673 0 0 0 65.188679-201.641169C892.913029 219.441404 729.085006 59.883041 527.710316 59.883041z m246.382783 520.515368c-0.28145 0.398222-0.565895 0.814409-0.814409 1.197661l-2.580959 4.248702-0.215579 0.251509c-0.452117 0.529965-0.898246 1.05993-1.311439 1.607859l-242.610152 315.326129-241.927485-315.329123a30.097216 30.097216 0 0 0-1.344374-1.637801l-3.592983-5.670924a281.899415 281.899415 0 0 1-52.98152-164.678363c0.721591-160.34283 135.742877-290.795041 300.990128-290.79504 165.513731 0 300.166737 130.227649 300.169731 290.280046a288.60931 288.60931 0 0 1-53.780959 165.199345z" fill="#333333" p-id="19386"></path><path d="M527.297123 259.326503a153.992234 153.992234 0 0 0-153.818573 153.818573 153.992234 153.992234 0 0 0 153.818573 153.815579 153.98924 153.98924 0 0 0 153.815579-153.815579 153.992234 153.992234 0 0 0-153.815579-153.818573z m0 245.44262a91.725848 91.725848 0 0 1-91.621053-91.621053 91.725848 91.725848 0 0 1 91.621053-91.621052 91.728842 91.728842 0 0 1 91.621052 91.621052 91.728842 91.728842 0 0 1-91.621052 91.609076z" fill="#333333" p-id="19387"></path></svg>
                        <span> {{tourInfo.address}}</span>
                    </p>
                    

                </li>
                <li @click="message">
                    <p>
                       <svg t="1637313267872" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19802" width="24" height="24"><path d="M607.249965 417.860865a252.517801 252.517801 0 1 0 252.514807 252.514808 252.799251 252.799251 0 0 0-252.514807-252.514808z" fill="#FFE39C" p-id="19803"></path><path d="M510.865216 132.422363c-230.27724 0-417.612351 187.341099-417.612351 417.609356s187.335111 417.609357 417.612351 417.609357 417.609357-187.332117 417.609357-417.609357-187.341099-417.609357-417.609357-417.609356z m0 770.970198a353.360842 353.360842 0 1 1 353.360842-353.360842 353.759064 353.759064 0 0 1-353.360842 353.360842z" fill="#333333" p-id="19804"></path><path d="M296.421053 550.923977m-59.883041 0a59.883041 59.883041 0 1 0 119.766082 0 59.883041 59.883041 0 1 0-119.766082 0Z" fill="#333333" p-id="19805"></path><path d="M512 550.923977m-59.883041 0a59.883041 59.883041 0 1 0 119.766082 0 59.883041 59.883041 0 1 0-119.766082 0Z" fill="#333333" p-id="19806"></path><path d="M727.578947 550.923977m-59.883041 0a59.883041 59.883041 0 1 0 119.766082 0 59.883041 59.883041 0 1 0-119.766082 0Z" fill="#333333" p-id="19807"></path></svg>
                        <span> {{isEnglish ? 'Introduction to more scenic spots':'更多景区介绍'}} </span>
                    </p>
                   
                    
                </li>
            </ul>
        </div>
        <div class="many">
            <div v-show="tourInfo.guides[0].value">
                <h2>
                    <span>{{isEnglish ? 'Food Guide':'美食指南'}} </span>
                </h2>
                <ul>
                    <li @click="zhinan(tourInfo.guides[0].value)">
                        <p>
                            {{isEnglish ? 'Food Guide':'美食指南'}} 
                        </p>
                    </li>
                </ul>
            </div>
            <div v-show="tourInfo.guides[1].value || tourInfo.guides[2].value">
                <h2>
                    <span>{{isEnglish ? 'Traffic guide':'交通指南'}}  </span>
                </h2>
                <ul>
                    <li @click="zhinan(tourInfo.guides[1].value)">
                        <p> {{isEnglish ? 'transit':"公交"}}</p>
                    </li>
                    <li @click="zhinan(tourInfo.guides[2].value)">
                        <p>{{isEnglish ? 'Self driving':"自驾"}}</p>
                    </li>
                </ul>
            </div>
            <div v-show="tourInfo.guides[3].value">
                <h2> 
                    <span>{{isEnglish ? 'Play introductio':"游玩攻略"}}</span>
               
                </h2>
                 <ul>
                    <li @click="zhinan(tourInfo.guides[3].value)">
                        <p>{{isEnglish ? 'Play introductio':"游玩攻略"}}</p>
                    </li>
                    
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import {
 
  baseImgHost,
 
} from "@/api/api";
import Audio from "@/components/audio";
import mapTop from "@/components/map";
import iconx from "@/components/iconx.vue";

export default {
    components:{
        Audio,
        mapTop,
        iconx
    },
    data() {
        return {
            tourInfo:{},
            baseImgHost,
            // 当前位置经度
            spointx: 0,
            // 当前位置纬度
            spointy: 0,
            isEnglish:false,
            audioList:[]
        }
    },
    created() {
        this.tourInfo=JSON.parse(localStorage.getItem("tourInfo"))
        this.spointx=Number(localStorage.getItem("lat"))
        this.spointy=Number(localStorage.getItem("log"))

    },
    mounted() {
        this.audioList=JSON.parse(localStorage.getItem("audioList"))
       
       
        if(this.$route.query.isEnglish=='false'){
            this.isEnglish=false
        }else{
            this.isEnglish=this.$route.query.isEnglish
        }
        // this.$refs.audio.setDefaultMusic(this.audioList[0]);
        
    },
    watch:{
        isEnglish(val){
           this.isEnglish=this.$route.query.isEnglish
        }
    },
    methods:{
        audioOpen(){
            
        },
        message(){
            this.$router.push({
                path:"tourMessage",
                query:{
                    isEnglish:this.isEnglish
                }
            })
        },
        zhinan(item){
            console.log(item)
            this.$router.push({
                path:"/zhinan",
                query:{
                    value:item
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
div{
    padding: 0;
    margin: 0;
}
*{
    list-style: none;
}
.container{
    display: flex;
    flex-direction: column;
    background: #eee;
    min-height: 100%;
    // position: relative;
    .titleImg{
        width: 100%;
        height: 300px;
        background: #fff;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .music{
        width: 100%;
        height: 1.1rem;
        // padding: 0 0.1rem;
        box-sizing: border-box;
        position: relative;
        z-index: 99;
        >div{
            width: 100%;
            height: 100%;
        //  background: #fff;

        }
        top: -25px;
        
    }
    .tourMsg{
        position: relative;
        width: 100%;
        height: auto;
        background: #fff;
        // top: -1rem;
        >ul{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            // padding-top: 1rem;
            box-sizing: border-box;
            >li{
                flex: none;
                height: 1rem;
                display: flex;
                padding: 0 .3rem;
                box-sizing: border-box;
                
                p{
                    width: 100%;
                    height: 100%;
                    //  background: brown;
                    border-bottom: 1px solid #ccc;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    span{
                        padding-left: 10px;
                        box-sizing: border-box;
                    }
                }
                // p:last-child{
                //     border: none;
                // }
                i{
                    font-size: 35px;
                   
                }
            }
            
            
        }
        ul li:last-child p{
                    border: none;
                }
    }
    .many{
        width: 100%;
        height: auto;
        
        background: #fff;
        margin-top: -.6rem;
        >div{
            padding: .2rem .4rem;
        box-sizing: border-box;
            h2{
                font-size: 20px;
                font-weight: normal;
                color: #555;
                span{
                    border-bottom: 5px solid 	#FFD700;
                }
            }
            ul{
                display: flex;
                padding-top: .3rem;
                box-sizing: border-box;
                li{
                    flex: none;
                    width: 50%;
                    font-size: 16px;
                    display: flex;
                    align-items: center;
                    // padding: .1rem .2rem;
                    padding-right: .3rem;
                    box-sizing: border-box;
                    // justify-content: s;
                    p{
                        background: #F5F7FA;
                        width: 100%;
                        height: 100%;
                        padding: .2rem 0;
                        box-sizing: border-box;
                        border-radius: 10px;
                        text-indent: 20px;
                    }
                }
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/views/tourStrategy.vue